import React from 'react';

const Footer = ({ setCurrentPage, goToLeaderboard }) => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-4">
              PortfolioMaths
            </h3>
            <p className="text-gray-300 mb-4">
              Empowering the next generation of traders with interview preparation tools and resources.
            </p>
          </div>
          
          <div></div>
          
          <div>
            <h4 className="font-semibold text-blue-400 mb-4">Platform</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => setCurrentPage('practice')} 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Practice
                </button>
              </li>
              <li>
                <button 
                  onClick={() => setCurrentPage('blog')} 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Blog
                </button>
              </li>
              <li>
                <button 
                  onClick={() => setCurrentPage('jobs')} 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Jobs
                </button>
              </li>
              <li>
                <button 
                  onClick={goToLeaderboard} 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Leaderboard
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; 2025 PortfolioMaths. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;